/** Internal admin tools (My Tables, Old Site DB, Old Site Bills) are localhost-only. */
export function isLocalInternalHost() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "::1";
}

export const LOCAL_INTERNAL_PATHS = ["/tables", "/oldsite", "/bills/manage"];

export function isLocalInternalPath(pathname = "") {
  return LOCAL_INTERNAL_PATHS.some(
    (pattern) => pathname === pattern || pathname.startsWith(`${pattern}/`),
  );
}
